// extracted by mini-css-extract-plugin
export default {"btnContainer":"custom-modal_btnContainer__sJjLj","content":"custom-modal_content__d+2-2","modalContainer":"custom-modal_modalContainer__ELPT5"};